/* 🤖 this file was generated by svg-to-ts */
export const DfIconEyeOpenSquare16: {
  name: 'eye-open-square-16';
  data: string;
} = {
  name: 'eye-open-square-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM7.994 5c-1.273 0-2.496.746-3.67 2.24l-.121.156-.05.074a1 1 0 0 0 .05 1.135C5.413 10.202 6.677 11 7.993 11c1.272 0 2.499-.746 3.68-2.237l.122-.157.048-.068a1 1 0 0 0-.048-1.146C10.576 5.798 9.309 5 7.994 5zM8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm.001 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/></svg>`
};
